;(function () {
  function bootPreUpsellDynamicRuntime() {
    if (window.__bbePreUpsellDynamicRuntimeInit) return

    const modal = document.querySelector("pre-upsell-modal")
    if (!modal) return

    window.__bbePreUpsellDynamicRuntimeInit = true

  function getModal() {
    return document.querySelector("pre-upsell-modal")
  }

  function getCheckoutUrl() {
    const modalEl = document.querySelector("pre-upsell-modal")
    return modalEl?.dataset.checkoutUrl || "/checkout"
  }
  const OFFERS_URL = "/apps/bbe-checkout-app/api/pre-upsell/offers"
  const MARKET_AVAILABILITY_URL = "/apps/bbe-checkout-app/api/market-availability"
  const EVENT_URL = "/apps/bbe-checkout-app/api/pre-upsell/event"
  const CART_VIEW_URL = "/apps/bbe-checkout-app/api/cart/view"
  /** Must be ≥ app `REQUEST_TIMEOUT_MS` in api.pre-upsell.offers.ts */
  const OFFERS_TIMEOUT_MS = 3000
  const MARKET_AVAILABILITY_TIMEOUT_MS = 800
  const RECENTLY_VIEWED_KEY = "bbe_ppup_recently_viewed_product_ids"
  const VISITOR_KEY_STORAGE = "bbe_ppup_visitor_key"
  const SESSION_KEY_STORAGE = "bbe_ppup_session_id"
  const UTM_SESSION_KEY = "bbe_ppup_utm"
  const LANDING_SESSION_KEY = "bbe_ppup_landing_path"
  const REFERRER_SESSION_KEY = "bbe_ppup_referrer"
  const ADD_MORE_SAVE_MORE_PATTERN = /add\s*more\s*save\s*more|addmoresavemore/i
  /** PPUP_4YOU automatic discount at checkout — show on dynamic cards before accept */
  const PPUP_CHECKOUT_DISCOUNT_RATE = 0.3
  const PPUP_CHECKOUT_DISCOUNT_LABEL = "30% OFF"

  const config = {
    enableDynamic: modal.dataset.enableDynamic === "true",
    marketHandle: modal.dataset.marketHandle || null,
    country: modal.dataset.country || (window.Shopify && window.Shopify.country) || "US",
    currency: modal.dataset.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD",
  }

  let checkoutExitHandlersBound = false

  function getPpupOverlay() {
    return document.querySelector(".pre-upsell__overlay")
  }

  function getPpupItemsContainer() {
    return getModal()?.querySelector(".pre-upsell__items")
  }

  function cartAddViaAjaxCart(body, options) {
    if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === "function") {
      return new Promise((resolve, reject) => {
        window.liquidAjaxCart.add(body, {
          ...options,
          lastCallback: (requestState) => {
            const cartBody = requestState?.responseData?.body
            if (cartBody?.status) {
              reject(new Error(cartBody.description || "cart add failed"))
              return
            }
            if (!requestState?.responseData?.ok) {
              reject(new Error("cart add failed"))
              return
            }
            resolve(cartBody)
          },
        })
      })
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body),
    }).then((res) => {
      if (!res.ok) throw new Error("cart add failed")
      return res.json()
    }).then((cartBody) => {
      if (cartBody?.status) throw new Error(cartBody.description || "cart add failed")
      return cartBody
    })
  }

  function cartAddFormViaAjaxCart(form, options) {
    if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === "function") {
      const body = new FormData(form)
      return new Promise((resolve, reject) => {
        window.liquidAjaxCart.add(body, {
          ...options,
          lastCallback: (requestState) => {
            const cartBody = requestState?.responseData?.body
            if (cartBody?.status) {
              reject(new Error(cartBody.description || "cart add failed"))
              return
            }
            if (!requestState?.responseData?.ok) {
              reject(new Error("cart add failed"))
              return
            }
            resolve(cartBody)
          },
        })
      })
    }
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      body: new FormData(form),
    }).then((res) => {
      if (!res.ok) throw new Error("cart add failed")
      return res.json()
    }).then((cartBody) => {
      if (cartBody?.status) throw new Error(cartBody.description || "cart add failed")
      return cartBody
    })
  }
  let activeOfferResponse = null
  let cachedDynamicOffers = null
  let checkoutInterceptBusy = false
  let checkoutInterceptQueued = false

  function readPageContext() {
    const el = document.getElementById("pre-upsell-page-context")
    if (!el) return null
    try {
      return JSON.parse(el.textContent || "null")
    } catch (e) {
      return null
    }
  }

  function getOrCreateVisitorKey() {
    try {
      const existing = localStorage.getItem(VISITOR_KEY_STORAGE)
      if (existing) return existing
      const key = "v_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10)
      localStorage.setItem(VISITOR_KEY_STORAGE, key)
      return key
    } catch (e) {
      return "v_fallback_" + Date.now()
    }
  }

  function getOrCreateSessionId() {
    try {
      const existing = sessionStorage.getItem(SESSION_KEY_STORAGE)
      if (existing) return existing
      const id = "s_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10)
      sessionStorage.setItem(SESSION_KEY_STORAGE, id)
      return id
    } catch (e) {
      return "s_fallback_" + Date.now()
    }
  }

  /** Shared identity for offers API, cart/view, and event ingest (spec 07). */
  function resolvePpupIdentity() {
    return {
      sessionId: getOrCreateSessionId(),
      visitorKey: getOrCreateVisitorKey(),
    }
  }

  function captureAttributionOnLoad() {
    try {
      const params = new URLSearchParams(window.location.search)
      const utm = {
        source: params.get("utm_source") || null,
        medium: params.get("utm_medium") || null,
        campaign: params.get("utm_campaign") || null,
      }
      if (utm.source || utm.medium || utm.campaign) {
        sessionStorage.setItem(UTM_SESSION_KEY, JSON.stringify(utm))
      }
      if (!sessionStorage.getItem(LANDING_SESSION_KEY)) {
        sessionStorage.setItem(LANDING_SESSION_KEY, window.location.pathname + window.location.search)
      }
      if (!sessionStorage.getItem(REFERRER_SESSION_KEY) && document.referrer) {
        sessionStorage.setItem(REFERRER_SESSION_KEY, document.referrer)
      }
    } catch (e) {
      /* ignore */
    }

    const pageCtx = readPageContext()
    if (pageCtx && pageCtx.pageProductId) {
      recordRecentlyViewedProductId(String(pageCtx.pageProductId))
    }
  }

  function recordRecentlyViewedProductId(productId) {
    if (!productId) return
    try {
      const raw = localStorage.getItem(RECENTLY_VIEWED_KEY)
      let ids = raw ? JSON.parse(raw) : []
      if (!Array.isArray(ids)) ids = []
      ids = ids.filter((id) => String(id) !== String(productId))
      ids.unshift(String(productId))
      ids = ids.slice(0, 10)
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(ids))
    } catch (e) {
      /* ignore */
    }
  }

  function getRecentlyViewedProductIds() {
    try {
      const raw = localStorage.getItem(RECENTLY_VIEWED_KEY)
      const ids = raw ? JSON.parse(raw) : []
      return Array.isArray(ids) ? ids.map(String) : []
    } catch (e) {
      return []
    }
  }

  function getStoredUtm() {
    try {
      const raw = sessionStorage.getItem(UTM_SESSION_KEY)
      if (!raw) return { source: null, medium: null, campaign: null }
      const parsed = JSON.parse(raw)
      return {
        source: parsed.source || null,
        medium: parsed.medium || null,
        campaign: parsed.campaign || null,
      }
    } catch (e) {
      return { source: null, medium: null, campaign: null }
    }
  }

  function getDeviceType() {
    const w = window.innerWidth || 0
    if (w <= 768) return "mobile"
    if (w <= 1024) return "tablet"
    return "desktop"
  }

  function getCustomerType() {
    const pageCtx = readPageContext()
    if (pageCtx && pageCtx.customerOrdersCount === 0) {
      return "new"
    }
    if (window.Shopify && window.Shopify.customer && window.Shopify.customer.id) {
      return "returning"
    }
    return "guest"
  }

  function formatMoney(amount, currency) {
    const n = Number(amount)
    if (!Number.isFinite(n)) return ""
    if (typeof window.Shopify !== "undefined" && typeof window.Shopify.formatMoney === "function") {
      try {
        return window.Shopify.formatMoney(Math.round(n * 100), window.money_format || "${{amount}}")
      } catch (e) {
        /* fall through */
      }
    }
    return new Intl.NumberFormat(undefined, { style: "currency", currency: currency || config.currency }).format(n)
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" })
    if (!res.ok) throw new Error("cart fetch failed")
    return res.json()
  }

  function extractBundleMaps(cart) {
    const bundleIdToLines = {}
    cart.items.forEach((item) => {
      const props = item.properties || {}
      const bundleId = props._bundle_id
      if (bundleId) {
        if (!bundleIdToLines[bundleId]) bundleIdToLines[bundleId] = []
        bundleIdToLines[bundleId].push(item)
      }
    })
    return bundleIdToLines
  }

  function buildCartLines(cart) {
    const bundleMaps = extractBundleMaps(cart)
    return cart.items.map((item) => {
      const props = item.properties || {}
      const bundleId = props._bundle_id
      const bundleComponentProductIds = []
      const bundleComponentVariantIds = []
      const bundleComponentSkus = []

      if (props._bundle_parent && bundleId && bundleMaps[bundleId]) {
        bundleMaps[bundleId].forEach((child) => {
          if (child.id !== item.id) {
            bundleComponentProductIds.push(String(child.product_id))
            bundleComponentVariantIds.push(String(child.variant_id))
            if (child.sku) bundleComponentSkus.push(String(child.sku))
          }
        })
      }

      return {
        productId: String(item.product_id),
        variantId: String(item.variant_id),
        sku: item.sku || null,
        quantity: item.quantity,
        bundleComponentProductIds,
        bundleComponentVariantIds,
        bundleComponentSkus,
      }
    })
  }

  function buildOffersRequestBody(cart) {
    const cartValue = Number(cart.total_price || 0) / 100
    const identity = resolvePpupIdentity()
    return {
      contractVersion: "ppup-v1",
      sessionId: identity.sessionId,
      visitorKey: identity.visitorKey,
      country: config.country,
      marketHandle: config.marketHandle,
      customerType: getCustomerType(),
      cartValue,
      currency: cart.currency || config.currency,
      device: getDeviceType(),
      cartLines: buildCartLines(cart),
      recentlyViewedProductIds: getRecentlyViewedProductIds(),
      utm: getStoredUtm(),
      referrer: sessionStorage.getItem(REFERRER_SESSION_KEY) || document.referrer || null,
      landingPath: sessionStorage.getItem(LANDING_SESSION_KEY) || window.location.pathname,
    }
  }

  async function fetchOffersWithTimeout() {
    let cart
    try {
      cart = await fetchCart()
    } catch (e) {
      return null
    }
    const body = buildOffersRequestBody(cart)
    const controller = new AbortController()
    const timer = setTimeout(() => controller.abort(), OFFERS_TIMEOUT_MS)
    try {
      const res = await fetch(OFFERS_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(body),
        signal: controller.signal,
      })
      if (!res.ok) return null
      return res.json()
    } catch (e) {
      return null
    } finally {
      clearTimeout(timer)
    }
  }

  async function hasActiveCartDiscount() {
    try {
      const cart = await fetchCart()

      if (cart.discount_codes && cart.discount_codes.length > 0) {
        const customerCodes = cart.discount_codes.filter(function (entry) {
          if (entry.applicable === false) return false
          const code = String(entry.code || "").trim()
          if (!code) return false
          return !ADD_MORE_SAVE_MORE_PATTERN.test(code)
        })
        if (customerCodes.length > 0) return true
      }

      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
        const blocking = cart.cart_level_discount_applications.filter(function (discount) {
          const title = String(discount.title || discount.description || "")
          return !ADD_MORE_SAVE_MORE_PATTERN.test(title)
        })
        if (blocking.length > 0) return true
      }

      return false
    } catch (e) {
      return false
    }
  }

  function normalizeVariantId(id) {
    const s = String(id || "")
    const match = s.match(/(\d+)$/)
    return match ? match[1] : s
  }

  function variantIdFromMarketAvailabilityResult(result) {
    const rawId =
      result?.variant_id_numeric ??
      result?.variantIdNumeric ??
      result?.variant_id ??
      result?.variantId
    if (rawId == null) return ""
    return normalizeVariantId(rawId)
  }

  function isMarketAvailabilityPurchasable(result) {
    if (!result || typeof result !== "object") return false
    const marketState = String(result.market_state ?? result.marketState ?? "").trim().toLowerCase()
    const hidden =
      marketState === "hide" ||
      result.hidden === true ||
      result.buy_box_hidden === true ||
      result.buyBoxHidden === true ||
      result.in_market_catalog === false
    if (hidden) return false
    return result.is_purchasable === true
  }

  async function filterByMarketAvailability(offers) {
    if (!offers || offers.length === 0) return []
    const variantIds = offers.map((o) => o.variantId).filter(Boolean)
    if (variantIds.length === 0) return offers

    const controller = new AbortController()
    const timer = setTimeout(() => controller.abort(), MARKET_AVAILABILITY_TIMEOUT_MS)
    try {
      const res = await fetch(MARKET_AVAILABILITY_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          variant_ids: variantIds,
          country: config.country,
          market_handle: config.marketHandle,
          surface: "pre_purchase_popup_upsell",
          bypass_cache: true,
          contract_version: "v1",
        }),
        signal: controller.signal,
      })
      if (!res.ok) return offers
      const data = await res.json()
      const purchasable = new Set(
        (data.results || [])
          .filter((r) => isMarketAvailabilityPurchasable(r))
          .map((r) => variantIdFromMarketAvailabilityResult(r))
          .filter(Boolean),
      )
      if (purchasable.size === 0) return offers
      const filtered = offers.filter((o) => purchasable.has(normalizeVariantId(o.variantId)))
      return filtered.length > 0 ? filtered : offers
    } catch (e) {
      return offers
    } finally {
      clearTimeout(timer)
    }
  }

  function filterCartDuplicates(offers, cart) {
    if (!offers || !cart) return offers || []
    const productIds = new Set(cart.items.map((i) => String(i.product_id)))
    const variantIds = new Set(cart.items.map((i) => String(i.variant_id)))
    const skus = new Set(cart.items.map((i) => i.sku).filter(Boolean))
    return offers.filter((o) => {
      if (productIds.has(String(o.productId))) return false
      if (variantIds.has(String(o.variantId))) return false
      if (o.sku && skus.has(o.sku)) return false
      return true
    })
  }

  function removeDynamicOfferCards() {
    getPpupItemsContainer()?.querySelectorAll("[data-ppup-dynamic-item]").forEach((el) => el.remove())
  }

  function showStaticItems() {
    getPpupItemsContainer()?.querySelectorAll("[data-ppup-static-item]").forEach((el) => {
      el.style.display = ""
    })
  }

  function hideStaticItems() {
    getPpupItemsContainer()?.querySelectorAll("[data-ppup-static-item]").forEach((el) => {
      el.style.display = "none"
    })
  }

  function restoreStaticItems() {
    removeDynamicOfferCards()
    showStaticItems()
    activeOfferResponse = null
    cachedDynamicOffers = null
  }

  function buildDynamicOfferCard(offer, responseMeta) {
    const catalogPrice = parseFloat(offer.price)
    const compareAtParsed = parseFloat(offer.compareAtPrice)
    const currency = offer.currency || config.currency
    const hasCatalogPrice = Number.isFinite(catalogPrice) && catalogPrice > 0
    const strikethroughBase = hasCatalogPrice
      ? Number.isFinite(compareAtParsed) && compareAtParsed > catalogPrice
        ? compareAtParsed
        : catalogPrice
      : 0
    const ppupPrice = hasCatalogPrice
      ? Math.round(catalogPrice * (1 - PPUP_CHECKOUT_DISCOUNT_RATE) * 100) / 100
      : 0
    const compareHtml =
      strikethroughBase > ppupPrice
        ? '<span class="pre-upsell__item-compare_at">' +
          formatMoney(strikethroughBase, currency) +
          "</span>"
        : ""
    const badgeHtml = hasCatalogPrice
      ? '<div class="pre-upsell__dynamic-badge" aria-hidden="true">' +
        escapeHtml(PPUP_CHECKOUT_DISCOUNT_LABEL) +
        "</div>"
      : ""
    const card = document.createElement("div")
    card.className = "pre-upsell__item"
    card.id = "preupsell-dynamic-" + offer.rank
    card.dataset.ppupDynamicItem = "true"
    card.dataset.variantId = offer.variantId
    card.dataset.offerId = offer.offerId
    card.dataset.rank = String(offer.rank)
    const imageUrl = safeImageUrl(offer.image)
    card.innerHTML =
      '<div class="pre-upsell__item-image">' +
      (imageUrl
        ? '<img src="' + imageUrl + '" alt="' + escapeHtml(offer.title || "") + '" width="200" height="200" loading="lazy">'
        : '<div class="pre-upsell__no-image">No Image</div>') +
      badgeHtml +
      "</div>" +
      '<div class="pre-upsell__item-content">' +
      '<div class="pre-upsell__stars"><span class="pre-upsell__fallback-stars">★★★★★</span></div>' +
      '<h3 class="pre-upsell__item-title">' +
      escapeHtml(offer.title || "") +
      "</h3>" +
      '<div class="pre-upsell__item-pricing">' +
      '<div class="pre-upsell__item-price">' +
      compareHtml +
      '<span class="pre-upsell__item-current-price">' +
      formatMoney(ppupPrice, currency) +
      "</span></div></div></div>" +
      '<div class="pre-upsell__item-action">' +
      '<button type="button" class="pre-upsell__add-button" data-upsell-add data-dynamic-offer="true">' +
      '<span class="btn-text">ADD IT</span></button></div>'
    card.dataset.productId = offer.productId
    if (offer.sku) card.dataset.sku = offer.sku
    return card
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, "&#39;")
  }

  function safeImageUrl(url) {
    const s = String(url || "").trim()
    if (!s) return ""
    try {
      const parsed = new URL(s, window.location.origin)
      if (parsed.protocol === "http:" || parsed.protocol === "https:") {
        return escapeAttr(parsed.href)
      }
    } catch (e) {
      /* reject invalid or unsafe protocols */
    }
    return ""
  }

  function renderDynamicOffers(offers, responseMeta) {
    const itemsContainer = getPpupItemsContainer()
    if (!itemsContainer) return false

    removeDynamicOfferCards()
    hideStaticItems()
    activeOfferResponse = responseMeta
    const sorted = [...offers].sort((a, b) => (a.rank || 0) - (b.rank || 0))
    cachedDynamicOffers = sorted
    sorted.forEach((offer) => {
      itemsContainer.appendChild(buildDynamicOfferCard(offer, responseMeta))
    })
    return sorted.length > 0
  }

  async function postCartViewImpression() {
    const identity = resolvePpupIdentity()
    const payload = {
      type: "__cartPreupsell",
      sessionId: identity.sessionId,
      visitorKey: identity.visitorKey,
    }
    try {
      await fetch(CART_VIEW_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      })
    } catch (e) {
      /* best-effort */
    }
  }

  async function postOfferEvent(eventType, offer, responseMeta) {
    const identity = resolvePpupIdentity()
    try {
      await fetch(EVENT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          contractVersion: "ppup-v1",
          eventType,
          sessionId: identity.sessionId,
          visitorKey: identity.visitorKey,
          mode: responseMeta?.mode || "dynamic",
          experimentVariant: responseMeta?.experimentVariant || null,
          algorithmVersion: responseMeta?.algorithmVersion || "v1",
          offerId: offer?.offerId || null,
          productId: offer?.productId || null,
          variantId: offer?.variantId || null,
          sku: offer?.sku || null,
          rank: offer?.rank || null,
          price: offer?.price || null,
          currency: offer?.currency || config.currency,
          fallbackUsed: responseMeta?.fallbackUsed || false,
          fallbackReason: responseMeta?.fallbackReason || "none",
          productsShown: responseMeta?.productsShown || null,
          country: config.country,
          device: getDeviceType(),
        }),
      })
    } catch (e) {
      /* best-effort */
    }
  }

  function openUpsell(invoker) {
    const modalEl = getModal()
    if (!modalEl) return
    if (typeof modalEl.open === "function") {
      modalEl.open(invoker || null)
      postCartViewImpression()
      return
    }
    modalEl.classList.add("show")
    getPpupOverlay()?.classList.add("show")
    postCartViewImpression()
  }

  function closeUpsellVisual() {
    const modalEl = getModal()
    if (!modalEl) return
    modalEl.classList.add("fading")
    getPpupOverlay()?.classList.remove("show")
    setTimeout(() => modalEl.classList.remove("show", "fading"), 220)
  }

  function goToCheckout() {
    clearAddedOverlays()
    window.location.href = getCheckoutUrl()
  }

  async function openStaticUpsellPath() {
    restoreStaticItems()
    document.querySelector("cart-drawer")?.close?.()
    openUpsell()
  }

  async function handleDynamicCheckoutPath() {
    try {
      if (await hasActiveCartDiscount()) {
        goToCheckout()
        return
      }

      const offersResponse = await fetchOffersWithTimeout()
      if (!offersResponse || offersResponse.mode === "static") {
        await openStaticUpsellPath()
        return
      }

      if (offersResponse.suppress && (!offersResponse.offers || offersResponse.offers.length === 0)) {
        postOfferEvent("suppressed", null, offersResponse)
        goToCheckout()
        return
      }

      let cart
      try {
        cart = await fetchCart()
      } catch (e) {
        await openStaticUpsellPath()
        return
      }

      let offers = filterCartDuplicates(offersResponse.offers || [], cart)
      offers = await filterByMarketAvailability(offers)

      if (offers.length === 0) {
        await openStaticUpsellPath()
        return
      }

      document.querySelector("cart-drawer")?.close?.()
      const rendered = renderDynamicOffers(offers.slice(0, 3), offersResponse)
      if (!rendered) {
        await openStaticUpsellPath()
        return
      }
      openUpsell()
    } catch (e) {
      await openStaticUpsellPath()
    }
  }

  function setDrawerCheckoutLoading(loading) {
    const drawer = document.querySelector("cart-drawer")
    if (drawer) {
      drawer.classList.toggle("cart-loading", loading)
    }
    document.querySelectorAll(".cart-drawer__button").forEach((btn) => {
      btn.setAttribute("aria-busy", loading ? "true" : "false")
    })
  }

  function runCheckoutIntercept() {
    checkoutInterceptBusy = true
    setDrawerCheckoutLoading(true)

    const done = () => {
      checkoutInterceptBusy = false
        if (checkoutInterceptQueued) {
        checkoutInterceptQueued = false
        if (getModal()?.classList.contains("show")) {
          setDrawerCheckoutLoading(false)
          return
        }
        runCheckoutIntercept()
        return
      }
      setDrawerCheckoutLoading(false)
    }

    if (config.enableDynamic) {
      handleDynamicCheckoutPath().finally(done)
    } else {
      document.querySelector("cart-drawer")?.close?.()
      openUpsell()
      done()
    }
  }

  function handleCartCheckoutIntercept(e) {
    if (e.target.closest("pre-upsell-modal")) return

    const trigger = e.target.closest(
      ".cart-drawer__button, [data-cart-drawer-checkout], [data-checkout-button], button[name=\"checkout\"]",
    )
    if (!trigger) return

    e.preventDefault()
    e.stopImmediatePropagation()

    if (checkoutInterceptBusy) {
      checkoutInterceptQueued = true
      setDrawerCheckoutLoading(true)
      return
    }

    runCheckoutIntercept()
  }

  function setupCheckoutExits() {
    if (checkoutExitHandlersBound) return
    if (window.__bbePreUpsellElementDefined) return
    checkoutExitHandlersBound = true

    document.querySelector(".pre-upsell__wrapper")?.addEventListener("click", (e) => {
      const checkoutLink = e.target.closest("[data-upsell-checkout]")
      if (checkoutLink) {
        e.preventDefault()
        goToCheckout()
        return
      }

      const closeBtn = e.target.closest(".pre-upsell__close")
      if (closeBtn) {
        e.preventDefault()
        closeUpsellVisual()
        setTimeout(goToCheckout, 180)
      }
    })

    getPpupOverlay()?.addEventListener("click", (e) => {
      e.preventDefault()
      closeUpsellVisual()
      setTimeout(goToCheckout, 180)
    })

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.classList.contains("show")) {
        closeUpsellVisual()
        setTimeout(goToCheckout, 180)
      }
    })
  }

  function buildDynamicLineProperties(offer, responseMeta) {
    return {
      _is_pre_purchase_popup_upsell: "true",
      _is_pre_upsell: "true",
      __cartPreupsell: "yes",
      _ppup_mode: "dynamic",
      __ppup_session_id: getOrCreateSessionId(),
      _ppup_offer_id: offer.offerId || "",
      _ppup_algo_version: responseMeta?.algorithmVersion || "v1",
      _ppup_fallback_used: String(responseMeta?.fallbackUsed === true),
      _ppup_fallback_reason: responseMeta?.fallbackReason || "none",
      _ppup_products_shown: String(responseMeta?.productsShown ?? (responseMeta?.offers?.length || 0)),
      _ppup_rank: String(offer.rank || ""),
      __track_source: "pre_purchase_popup_upsell",
      __track_event: "prePurchasePopupUpsellAdd",
      __track_slot: String(offer.rank || ""),
    }
  }

  function ensureStaticFormAttribution(form) {
    if (!config.enableDynamic || !form) return

    const sessionId = getOrCreateSessionId()
    let sessionInput = form.querySelector('input[name="properties[__ppup_session_id]"]')
    if (!sessionInput) {
      sessionInput = document.createElement("input")
      sessionInput.type = "hidden"
      sessionInput.name = "properties[__ppup_session_id]"
      form.appendChild(sessionInput)
    }
    sessionInput.value = sessionId
  }

  function syncStaticFormAttribution() {
    if (!config.enableDynamic) return
    getModal()?.querySelectorAll("form[action*='/cart/add']").forEach(ensureStaticFormAttribution)
  }

  async function revalidateOfferVariant(offer) {
    const filtered = await filterByMarketAvailability([offer])
    return filtered.length > 0
  }

  async function addDynamicOffer(offer, btn) {
    const responseMeta = activeOfferResponse
    if (!await revalidateOfferVariant(offer)) {
      const card = btn.closest(".pre-upsell__item")
      if (card) card.remove()
      return false
    }

    const properties = buildDynamicLineProperties(offer, responseMeta)
    const body = {
      items: [
        {
          id: Number(normalizeVariantId(offer.variantId)),
          quantity: 1,
          properties,
        },
      ],
    }

    postOfferEvent("add_attempt", offer, responseMeta)

    const res = await cartAddViaAjaxCart(body, {
      info: { should_keep_drawer_closed: true },
    })

    if (!res) return false
    return true
  }

  async function onUpsellAddClick(e) {
    const btn = e.target.closest("[data-upsell-add]")
    if (!btn) return
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    if (btn.dataset.dynamicOffer === "true") {
      const card = btn.closest(".pre-upsell__item")
      const offer = {
        offerId: card?.dataset.offerId,
        variantId: card?.dataset.variantId,
        rank: Number(card?.dataset.rank || 0),
        productId: card?.dataset.productId,
        sku: card?.dataset.sku || null,
      }
      btn.disabled = true
      try {
        const ok = await addDynamicOffer(offer, btn)
        if (!ok) {
          btn.disabled = false
          return
        }
        if (card) {
          card.classList.add("added")
          const btnText = btn.querySelector(".btn-text")
          if (btnText) btnText.textContent = "ADDED"
          btn.style.opacity = "0.7"
          updateDynamicSavings()
        }
      } catch (err) {
        console.error(err)
        btn.disabled = false
      }
      return
    }

    const form = btn.closest("form")
    if (!form) return

    ensureStaticFormAttribution(form)

    btn.disabled = true
    try {
      await cartAddFormViaAjaxCart(form, {
        info: { should_keep_drawer_closed: true },
      })

      const card = btn.closest(".pre-upsell__item")
      if (card) {
        card.classList.add("added")
        const btnText = btn.querySelector(".btn-text")
        if (btnText) btnText.textContent = "ADDED"
        btn.disabled = true
        btn.style.opacity = "0.7"
        updateDynamicSavings()
      }
    } catch (err) {
      console.error(err)
      btn.disabled = false
    }
  }

  function updateDynamicSavings() {
    const addedCards = document.querySelectorAll(".pre-upsell__item.added")
    let totalSavings = 0

    addedCards.forEach((card) => {
      const comparePriceEl = card.querySelector(".pre-upsell__item-compare_at")
      const currentPriceEl = card.querySelector(".pre-upsell__item-current-price")

      if (comparePriceEl && currentPriceEl) {
        const comparePrice = parseFloat(comparePriceEl.textContent.replace(/[^0-9.-]/g, ""))
        const currentPrice = parseFloat(currentPriceEl.textContent.replace(/[^0-9.-]/g, ""))

        if (comparePrice > currentPrice) {
          totalSavings += comparePrice - currentPrice
        }
      }
    })

    let savingsEl = document.querySelector(".pre-upsell__save-amount")
    if (!savingsEl) {
      savingsEl = document.createElement("p")
      savingsEl.className = "pre-upsell__save-amount"
      const footer = document.querySelector(".pre-upsell__footer")
      const footerActions = document.querySelector(".pre-upsell__footer-actions")
      footer.insertBefore(savingsEl, footerActions)
    }

    if (totalSavings > 0) {
      savingsEl.innerHTML = "You're saving <span>$" + totalSavings.toFixed(2) + "</span>."
      savingsEl.style.display = "block"
    } else {
      savingsEl.style.display = "none"
    }
  }

  function clearAddedOverlays() {
    document.querySelectorAll(".pre-upsell__item.added").forEach((card) => {
      card.classList.remove("added")
      const button = card.querySelector("button[data-upsell-add]")
      if (button) {
        const btnText = button.querySelector(".btn-text")
        if (btnText) btnText.textContent = "Add it"
        button.disabled = false
        button.style.opacity = "1"
      }
    })

    const savingsEl = document.querySelector(".pre-upsell__save-amount")
    if (savingsEl) savingsEl.style.display = "none"
  }

  function initPreUpsell() {
    if (config.enableDynamic) {
      captureAttributionOnLoad()
      syncStaticFormAttribution()
    }

    document.removeEventListener("click", handleCartCheckoutIntercept, true)
    document.addEventListener("click", handleCartCheckoutIntercept, true)

    document.removeEventListener("click", onUpsellAddClick, true)
    document.addEventListener("click", onUpsellAddClick, true)

    document.removeEventListener("liquid-ajax-cart:request-end", handlePpupSectionRefresh)
    document.addEventListener("liquid-ajax-cart:request-end", handlePpupSectionRefresh)

    setupCheckoutExits()
  }

  function handlePpupSectionRefresh() {
    if (!config.enableDynamic || !cachedDynamicOffers?.length || !activeOfferResponse) return
    const modalEl = getModal()
    if (!modalEl) return
    if (!modalEl.classList.contains("show") && !checkoutInterceptBusy) return
    requestAnimationFrame(() => {
      const liveModal = getModal()
      if (!liveModal) return
      if (!liveModal.classList.contains("show") && !checkoutInterceptBusy) return
      renderDynamicOffers(cachedDynamicOffers, activeOfferResponse)
    })
  }

  window.__bbePreUpsellRunCheckoutIntercept = runCheckoutIntercept

  initPreUpsell()
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootPreUpsellDynamicRuntime)
  } else {
    bootPreUpsellDynamicRuntime()
  }
})()
